var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _g3, _path9, _path0, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgSmtpConnect = function SvgSvgSmtpConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-smtp-connect_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.008 40.648a21.504 21.504 0 1 1-43.008 0 21.504 21.504 0 0 1 43.008 0Z",
    fill: "#81E6D9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-smtp-connect_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-smtp-connect_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 31,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.939 31H29v20h19.939V31Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-smtp-connect_svg__c)",
    fill: "#2D2F7A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.527 39.1a.5.5 0 0 1-.498-.5v-5.5c0-.35-.2-.65-.549-.65a.65.65 0 0 0-.548.65v5.55c0 .3-.25.5-.498.5-.25 0-.499-.25-.499-.5v-5.5c-.05-.85.648-1.65 1.545-1.7h.05c.898.05 1.595.85 1.545 1.75v5.5c-.05.15-.299.4-.548.4ZM43.456 39.1a.5.5 0 0 1-.499-.5v-5.5c0-.35-.199-.65-.548-.65a.65.65 0 0 0-.548.65v5.55c0 .3-.25.5-.499.5s-.498-.25-.498-.5v-5.5c-.05-.85.648-1.65 1.545-1.7h.05c.897.05 1.595.85 1.545 1.75v5.5c-.05.15-.299.4-.548.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.462 50.45h-5.085a.5.5 0 0 1-.498-.5v-1.4c0-1.55-.947-2.2-1.994-3-1.196-.85-2.542-1.85-2.542-4.1V39c0-.3.249-.5.498-.5h14.157a.5.5 0 0 1 .498.5v2.45c0 2.4-1.545 3.75-2.841 4.8-.897.75-1.695 1.45-1.695 2.3v1.4c.05.3-.2.5-.498.5Zm-4.586-1h4.087v-.85c0-1.35 1.047-2.25 2.094-3.1 1.196-1 2.442-2.05 2.442-4v-2H32.34v1.95c0 1.75.998 2.45 2.094 3.25 1.147.85 2.443 1.75 2.443 3.85v.9Z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.644 86.728c20.36 0 36.864-16.505 36.864-36.864 0-20.36-16.504-36.864-36.864-36.864-20.359 0-36.864 16.505-36.864 36.864 0 20.36 16.505 36.864 36.864 36.864Z",
    fill: "#2D2F7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.436 36.046H138.9a4.607 4.607 0 0 1 4.608 4.608v18.464a4.61 4.61 0 0 1-4.608 4.608h-18.464a4.607 4.607 0 0 1-4.608-4.608V40.652a4.607 4.607 0 0 1 4.608-4.606Z",
    stroke: "#81E6D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.687 45.42h5.955a1.483 1.483 0 0 1 1.485 1.488v5.953a1.491 1.491 0 0 1-1.485 1.487h-5.955a1.486 1.486 0 0 1-1.484-1.487v-5.953a1.488 1.488 0 0 1 1.484-1.487ZM126.163 35.234v-3.366m7.004 3.366v-3.366M133.167 64.534V67.9m-7.004-3.366V67.9M115.014 53.385h-3.366m3.366-7.004h-3.366M144.314 46.38h3.366m-3.366 7.005h3.366",
    stroke: "#81E6D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.397 66.226a7.658 7.658 0 1 1-15.316 0 7.658 7.658 0 0 1 15.316 0ZM74.212 30.06a4.608 4.608 0 1 1 9.217 0 4.608 4.608 0 0 1-9.217 0Z",
    fill: "#EAEAF7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "svg-smtp-connect_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 67,
    width: 10,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.089 67.605h9.052v9.052h-9.052v-9.052Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-smtp-connect_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.962 76.657h-4.694a2.181 2.181 0 0 1-2.179-2.18v-4.693a2.185 2.185 0 0 1 2.179-2.18h4.694a2.182 2.182 0 0 1 2.179 2.18v4.694a2.185 2.185 0 0 1-2.179 2.179Zm-4.694-7.373a.506.506 0 0 0-.503.503v4.69a.504.504 0 0 0 .503.503h4.694a.5.5 0 0 0 .5-.502v-4.694a.5.5 0 0 0-.503-.503l-4.691.003Z",
    fill: "#EAEAF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "svg-smtp-connect_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 33,
    width: 14,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.929 47.009h-13.877V33.133h13.877v13.876Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-smtp-connect_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.393 33.133h7.195a3.343 3.343 0 0 1 3.341 3.34v7.196a3.345 3.345 0 0 1-3.341 3.34h-7.194a3.344 3.344 0 0 1-3.34-3.34v-7.195a3.344 3.344 0 0 1 3.34-3.34m7.194 11.306a.773.773 0 0 0 .771-.771v-7.195a.773.773 0 0 0-.771-.771h-7.194a.769.769 0 0 0-.771.77v7.196a.77.77 0 0 0 .771.77h7.194Z",
    fill: "#EAEAF7"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.184 65.224a21.503 21.503 0 1 1-43.006 0 21.503 21.503 0 0 1 43.006 0Z",
    fill: "#81E6D9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-smtp-connect_svg__f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-smtp-connect_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 56,
    width: 20,
    height: 20
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M226.939 56H207v20h19.939V56Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-smtp-connect_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.92 74.95c-1.346 0-2.493-.95-2.493-2.1 0-.25.05-.45.1-.65.149-.4.399-.7.748-.9.049-.05.049-.1.099-.1s0-.1-.05-.15l-.049-.05-.05-.05h-3.689c-.299 0-.498-.2-.498-.5V66.8l-.15-.15c-.1 0-.149.05-.199.1-.2.3-.499.55-.848.7-.249.1-.448.1-.648.15-.498 0-.947-.15-1.346-.5-.498-.45-.797-1.15-.797-1.85-.05-1.35.847-2.5 1.994-2.55h.149c.249 0 .449.05.648.1.399.15.698.4.898.75.049.05.099.1.199.1.05 0 .1-.05.149-.15v-5.15c0-.3.2-.5.499-.5h4.137c.648.2.997.9.798 1.5l-.15.3-.299.3c-.199.15-.299.3-.399.45-.049.05-.049.2-.049.3 0 .6.697 1.1 1.495 1.1.797 0 1.495-.5 1.495-1.1 0-.1 0-.2-.05-.3-.049-.15-.199-.3-.348-.45a1.13 1.13 0 0 1-.499-.75c-.05-.3 0-.6.199-.9.1-.1.15-.2.3-.3.099-.05.199-.15.348-.2.05-.05.15-.05.2-.05h3.689c.299 0 .498.2.498.5v5.1l.15.15c.099 0 .149-.05.199-.1.199-.3.498-.55.897-.7.249-.1.449-.1.648-.15.499 0 .947.2 1.346.55.499.45.748 1.15.748 1.9 0 1.35-.897 2.5-2.044 2.5h-.1c-.249 0-.448-.05-.648-.1-.398-.15-.698-.4-.897-.75-.05-.05-.1-.05-.199-.1-.05.05-.1.05-.15.15v3.8c0 .3-.199.5-.498.5h-3.888c-.05.05-.05.15-.05.25 0 0 0 .05.05.05l.049.05c.3.2.549.5.698.85.1.25.1.45.15.65-.05 1.2-1.147 2.1-2.492 2.1ZM212.035 70h3.339c.05 0 .15 0 .2.05.099.05.249.1.349.2.099.05.199.15.249.25.199.25.249.55.199.9-.05.3-.249.6-.498.75-.15.1-.299.25-.349.45 0 .05-.05.2-.05.3 0 .6.698 1.05 1.495 1.05.798 0 1.496-.5 1.496-1.1 0-.1 0-.2-.05-.3-.05-.15-.199-.3-.349-.45-.15-.1-.199-.2-.299-.3l-.15-.3c-.199-.65.15-1.3.798-1.5H222.054v-3.3c0-.05 0-.15.05-.2.149-.4.498-.65.897-.8h.05c.448-.05.897.1 1.146.45.15.2.299.3.449.4.1.05.199.05.299.05h.05c.598 0 1.047-.7 1.047-1.5 0-.45-.2-.9-.449-1.2-.15-.15-.349-.25-.648-.25-.1 0-.199 0-.299.05-.15.05-.299.2-.449.35-.299.4-.748.55-1.196.5h-.05c-.399-.1-.748-.4-.897-.8-.1-.05-.1-.1-.1-.2v-4.7h-3.19l-.05.05-.05.05c-.05.05-.05.1-.05.15 0 .05 0 .1.1.1.299.2.548.55.748.9 0 .2.05.4.05.6 0 1.15-1.097 2.1-2.493 2.1-1.346 0-2.492-.95-2.492-2.1 0-.25.05-.45.1-.65.149-.4.398-.7.747-.9l.05-.05v-.05c.05-.1 0-.2-.1-.25h-3.389v4.75c0 .05 0 .15-.05.2-.15.4-.498.65-.897.8h-.05c-.449.05-.897-.1-1.147-.45-.149-.2-.299-.3-.448-.4-.1-.05-.2-.05-.299-.05h-.1c-.548.05-1.047.75-.997 1.55 0 .45.199.9.499 1.15.149.1.348.25.648.25.099 0 .199 0 .299-.05.149-.05.299-.2.448-.35.299-.4.748-.55 1.197-.5h.049c.399.15.748.4.898.8.05.05.05.15.05.2V70Z",
    fill: "#2D2F7A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-smtp-connect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v140H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-smtp-connect_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(29 31)",
    d: "M0 0h19.939v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-smtp-connect_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(207 56)",
    d: "M0 0h19.939v20H0z"
  })))));
};
export default SvgSvgSmtpConnect;